import { render, staticRenderFns } from "./messageDemo.vue?vue&type=template&id=6ae82d2e&scoped=true&"
import script from "./messageDemo.vue?vue&type=script&lang=js&"
export * from "./messageDemo.vue?vue&type=script&lang=js&"
import style0 from "./messageDemo.vue?vue&type=style&index=0&id=6ae82d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae82d2e",
  null
  
)

export default component.exports